import { api } from "api/common";
import { createActionsHook } from "react-redux-actions-hook";
import { setToastMessage, setBusy } from "../app/actions";
import { AuthActionType, AuthResponseStatus, REGISTRATION_SUCCESSFUL } from "./constants";
import {
  USER_LOGIN_URL,
  GOOGLE_LOGIN_URL,
  USER_REGISTER_URL,
  ME_USER_URL,
  USER_LOGOUT_URL,
  PROCESS_INVITE,
  CHECK_INVITE,
  LOAD_INVITE,
  RESET_PASSWORD,
  REQUEST_RESET_PWD,
  RESEND_VERIFICATION,
  VERIFY_EMAIL,
  EMAIL_EXISTS_URL
} from "api/constants";
import { AppRouteURI } from "../../router/RoleBasedAccess";
import { push } from "connected-react-router";
import { aboutMe } from "components/settings/actions";
import { UNAUTHORIZED_USER_RESPONSE } from "./constants";
import { clearSessionData } from "local-store";

export const setAuthState = (loggedIn) => {
  return { type: AuthActionType.SET_AUTH, loggedIn };
};

export const setRole = ({ role }) => {
  return { type: AuthActionType.SET_ROLE, role };
};

export const setGuser = ({ role }) => {
  return { type: AuthActionType.SET_GUSER, role };
};

export const setFetching = (fetching) => {
  return { type: AuthActionType.SET_FETCHING, fetching };
};

export const setRegistration = (register) => {
  return { type: AuthActionType.SET_REGISTRATION, register };
};

export const setInviteData = (data) => {
  return { type: AuthActionType.SET_INVITE_DATA, data };
};

export const login = (email, password) => {
  return (dispatch) => {
    // api function handles the API error message
    api(
      USER_LOGIN_URL,
      {
        method: "POST",
        body: JSON.stringify({ email, password }),
      },
      dispatch
    )
      .then(() => {
        dispatch(loadMe());
        dispatch(setAuthState(true));
      })
      .catch((error) => {
        if (error.message === UNAUTHORIZED_USER_RESPONSE) {
          dispatch({
            type: AuthActionType.AUTH_ERROR,
            payload: { error: true },
          });
        }
        // dispatch(
        //   setToastMessage({
        //     message: error.message !== UNAUTHORIZED_USER_RESPONSE ? error.message : "",
        //     type: error.message !== UNAUTHORIZED_USER_RESPONSE ? "error" : "",
        //   })
        // );
      });
  };
};

export const renderVerificationMessage = (show) => {
  return (dispatch) => {
    dispatch({
      type: AuthActionType.AUTH_ERROR,
      payload: { error: show },
    });
  };
}

export const googleLogin = (data) => {
  return (dispatch) => {
    api(
      GOOGLE_LOGIN_URL,
      {
        method: "POST",
        body: JSON.stringify(data),
      },
      dispatch
    )
      .then((res) => {
        dispatch(loadMe());
        dispatch(setAuthState(res.isLoggedIn));
        dispatch(setGuser(true));
        dispatch(
          setToastMessage({
            message: "Logged in through google successfully",
            type: "success",
          })
        );
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const resendVerification = (email) => {
  return (dispatch) => {
    api(
      RESEND_VERIFICATION,
      {
        method: "POST",
        body: JSON.stringify({ email }),
      },
      dispatch
    )
      .then(() => {
        dispatch(
          setToastMessage({
            message: "Verification email sent",
            type: "success",
          })
        );
      })
      .catch((error) => {
        //Handle Error
      });
  };
}

export const showToast = (message, type) => {
  return (dispatch) => {
    dispatch(
      setToastMessage({
        message,
        type,
      })
    );
}};

export const verifyEmail = (token) => {
  return (dispatch) => {
    api(
      `${VERIFY_EMAIL}/${token}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((res) => {
        dispatch({
          type: AuthActionType.SET_VERIFIED,
          payload: { verified: res.verified },
        })
        dispatch(setToastMessage({
          message: "Email verified successfully",
          type: "success",
        }))
      })
      .catch((error) => {
        //Handle Error
        dispatch(setToastMessage({
          message: error.message,
          type: "error",
        }))
      });
  };
};

export const register = (registrationInfo) => {
  const data = { ...registrationInfo };
  delete data.role;
  return (dispatch) => {
    api(
      USER_REGISTER_URL,
      {
        method: "POST",
        body: JSON.stringify(data),
      },
      dispatch
    )
      .then((res) => {
      // Commented this line becuase remove the TOAST from the signUp (CURVE-529)
      //   dispatch(
      //     setToastMessage({
      //       message: res.message,
      //       type: res.message === REGISTRATION_SUCCESSFUL ?
      //         "success" : res.status ?
      //         AuthResponseStatus[res.status] :
      //         "warning",
      //     })
      //   );
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const email_exists = (emailId, setEmailExistsError) => {
  return (dispatch) => {
    api(
      `${EMAIL_EXISTS_URL}/${emailId}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then((res) => {
        setEmailExistsError(res.response)
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const processInvite = (data) => {
  return (dispatch, stateFn) => {
    const { query } = stateFn().router.location;
    api(
      PROCESS_INVITE,
      {
        method: "POST",
        body: JSON.stringify({ ...data, ...query }),
      },
      dispatch
    )
      .then((data) => {
        if (data?.success) {
          dispatch(push(AppRouteURI.LOGIN));
          dispatch(
            setToastMessage({
              message: "Successfully registered",
              type: "success",
            })
          );
        }
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Invalid Invite",
            type: "error",
          })
        );
      });
  };
};

export const loadMe = () => {
  return (dispatch) => {
    dispatch(setFetching(true));
    dispatch(setBusy(true));
    api(ME_USER_URL, {}, dispatch)
      .then((data) => {
        dispatch(setAuthState(data.isLoggedIn));
        if (data.isLoggedIn) {
          dispatch(aboutMe());
        }
        dispatch(setRole(data));
        dispatch(setFetching(false));
      })
      .catch((error) => {
        //Handle Error
        dispatch(setFetching(false));
      });
  };
};

export const logout = () => {
  return (dispatch) => {
    api(USER_LOGOUT_URL, {}, dispatch)
      .then((data) => {
        dispatch(setAuthState(data.isLoggedIn));
        dispatch(push(AppRouteURI.LOGIN));
        clearSessionData('dropdownData')
      })
      .catch((error) => {
        //Handle Error
      });
  };
};

export const checkInvite = () => {
  return (dispatch, stateFn) => {
    const { location } = stateFn().router;
    const { query } = location;
    const { token } = query;
    api(
      CHECK_INVITE,
      {
        method: "POST",
        body: JSON.stringify({ token }),
      },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message,
            type: "success",
          })
        );
      })
      .catch((error) => {
        dispatch(
          setToastMessage({
            message: error.message || "Invalid Invite",
            type: "error",
          })
        );
      });
  };
};

export const loadInviteDetails = () => {
  return (dispatch, stateFn) => {
    const { location } = stateFn().router;
    const { query } = location;
    const { token } = query;
    if (!token) {
      dispatch(push(AppRouteURI.HOME));
    }
    api(
      `${LOAD_INVITE}/${token}`,
      {
        method: "GET",
      },
      dispatch
    )
      .then(({ data }) => {
        dispatch(setInviteData(data));
      })
      .catch((error) => {
        dispatch(push(AppRouteURI.HOME));
      });
  };
};

export const resetPasswordWithToken = (new_password, history) => {
  return (dispatch, stateFn) => {
    const { location } = stateFn().router;
    const { query } = location;
    const { token } = query;
    if (!token) {
      dispatch(push(AppRouteURI.HOME));
    }
    api(
      `${RESET_PASSWORD}`,
      {
        method: "POST",
        body: JSON.stringify({ token, new_password }),
      },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message || "Reset Successful",
            type: "success",
          }),
          history.push(`${AppRouteURI.LOGIN}`)
        );
      })
      .catch((error) => {
        //do nothing
      });
  };
};

export const requestResetPassword = (email) => {
  return (dispatch) => {
    api(
      `${REQUEST_RESET_PWD}/${email}`,
      {
        method: "POST",
      },
      dispatch
    )
      .then((res) => {
        dispatch(
          setToastMessage({
            message: res.message || "Email Sent",
            type: "success",
          })
        );
      })
      .catch((error) => {
        //do nothing
      });
  };
};

export default createActionsHook({
  loadMe,
  logout,
  register,
  verifyEmail,
  email_exists,
  renderVerificationMessage,
  showToast,
  resendVerification,
  googleLogin,
  login,
  processInvite,
  setRegistration,
  checkInvite,
  loadInviteDetails,
  resetPasswordWithToken,
  requestResetPassword,
});
